var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('h1',{staticClass:"mb-6"},[_vm._v("Intercom")]),_c('div',[_vm._v("Joining an intercom channel is only possible in the linkbox app.")]),_c('app-get-our-app')],1)}
var staticRenderFns = []

export { render, staticRenderFns }